module.exports = __webpack_public_path__ + "img/what_for_me.aae45a07.png";